import React from "react";
import { Card, CardHeader, CardText } from "material-ui/Card";
import RaisedButton from "material-ui/RaisedButton";
import Loading from "layoutComponents/Loading";
import { houseEquipment } from "../../constants/houseEquipmentConfig";

class CpeEquipment extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      serialNumber: "",
      isValid: false,
    };

    this.handleEquipmentChanged = this.handleEquipmentChanged.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  handleEquipmentChanged(e) {
    e.preventDefault();
    const newSerialNumber = e.target.value;
    this.setState({
      serialNumber: newSerialNumber,
      isValid: true,
    });
  }

  handleSubmit() {
    const { accountNumber, orderId, workOrderActions } = this.props;
    const { serialNumber } = this.state;

    workOrderActions.addEquipmentBySerialStarted(
      {
        accountNumber: accountNumber,
        serialNumber: serialNumber,
        itemNumber: "",
      },
      "cpeEquipmentAdd",
      orderId
    );
  }

  resetState() {
    const { workOrderActions, orderId, techInventoryActions, orderUserId } =
      this.props;

    workOrderActions.resetCpeEquipmentAdd("cpeEquipmentAdd", orderId);

    techInventoryActions.getTechInventoryStarted(
      { isSelf: false },
      orderUserId
    );

    this.setState({
      serialNumber: "",
      isValid: false,
    });
  }

  render() {
    const { title, loading, updateMessage, techInventory, successfulAdd } =
      this.props;
    const { serialNumber, isValid } = this.state;

    const reducedPaddingStyle = {
      paddingTop: "5px",
      paddingBottom: "5px",
    };

    const labelStyle = {
      fontSize: "11px",
      paddingLeft: "8px",
      paddingRight: "8px",
    };

    const filteredTechInventory = techInventory.filter(
      (item) => !houseEquipment.includes(item.get("itemPart"))
    );

    return (
      <div>
        <Loading isLoading={loading} />
        <Card
          expanded={false}
          style={{
            marginBottom: "8px",
          }}
        >
          <CardHeader
            avatar={null}
            style={reducedPaddingStyle}
            actAsExpander={false}
            title={title}
            showExpandableButton={false}
          >
            <RaisedButton
              style={{
                float: "right",
                marginBottom: "5px",
              }}
              primary={true}
              labelStyle={labelStyle}
              disabled={!isValid}
              label={successfulAdd ? "Add More Equipment" : "Add"}
              onClick={successfulAdd ? this.resetState : this.handleSubmit}
              key="updateDongleEquipment"
            />
          </CardHeader>
          <CardText style={reducedPaddingStyle}>
            {updateMessage}
            <div>
              <select
                className="browser-default"
                value={serialNumber}
                key={serialNumber || "default"}
                onChange={this.handleEquipmentChanged}
              >
                <option value="" disabled>
                  -- Select equipment --
                </option>
                {filteredTechInventory &&
                  filteredTechInventory.map((item) => (
                    <option
                      style={{ fontSize: "10px" }}
                      key={`tech_equip_${item.get("serialNumber")}`}
                      value={item.get("serialNumber") || ""}
                      disabled={false}
                    >
                      {item.get("serialNumber")}&nbsp; (
                      {item.get("description")})
                    </option>
                  ))}
              </select>
            </div>
          </CardText>
        </Card>
      </div>
    );
  }
}

export default CpeEquipment;



// WEBPACK FOOTER //
// ./src/components/equipment/CpeEquipment.js